import CommercialGraphicsServices from "@/services/CommercialGraphicsServices";
const state = {
     semanaDetalleExcel: [],

};

const getters = {
    semanaDetalleExcel: state => {
        return state.semanaDetalleExcel;
    }, 

};

const actions = {
    

};


const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
};